import React, { useState } from "react";
import { Container, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import BackgroundImage from "@components/BackgroundImageCst";
import HeroCst from "@components/HeroCst";
import Breadcrumb from "@components/Breadcrumb";
import ModalDownloadUploadCst from "@components/ModalDownloadUploadCst";
import CardHomeCst from "@components/CardHomeCst";
import { useAuth } from "@context/auth";
import { ActionUploadDownloadIterface } from "@components/ModalDownloadUploadCst/types";
import AnimationFadeIn from "@components/AnimationFadeIn";
import { useResetFilters } from "@hooks/useFiltersProvider";
import { useParams } from "react-router-dom";
import { useMenu, useNavigaionRoutes } from "@hooks/useNavigation";

const FoundedTrainingCorporate: React.FC = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const { id } = useParams();
  const { t } = useTranslation(["menu", "common"]);

  const [configData, setConfigData] = useState<
    ActionUploadDownloadIterface | undefined
  >();

  const menuItem = useMenu();
  const navigation = useNavigaionRoutes();

  const trainingSection = ["usermgmt.corporates.funded_training.read"];

  useResetFilters();

  let trainingMenu: any[] = [];

  if (menuItem.length > 0) {
    trainingMenu = navigation
      .find((el) => el.to === "corporate")
      ?.children?.find((el: any) => el.to === "foundedTraining")
      ?.children?.filter((el: { section: string }) => {
        return (
          user?.permissions?.includes(el.section) &&
          trainingSection?.includes(el.section)
        );
      });
  }

  return (
    <AnimationFadeIn>
      <BackgroundImage
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-skills.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("corporate.foundedTraining.title")}
          description={t("corporate.foundedTraining.description")}
        />
        <Grid container spacing={3}>
          {trainingMenu.map((card: any, index: number) => (
            <Grid key={index} item xs={12} md={6} xl={4}>
              <CardHomeCst
                image={card.image}
                title={card.text}
                to={
                  !["validation-autotagging"].includes(card.to)
                    ? card.to
                    : undefined
                }
                description={card.description}
                secondaryBtnLabel={card.buttonLabel}
                uploadBtn={["validation-autotagging"].includes(card.to)}
                handleUpload={() => console.log("ciao")}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
      <ModalDownloadUploadCst
        open={!!open}
        setOpen={() => {
          setOpen(false);
        }}
        title={configData && configData.labelTranslate}
        data={configData}
      />
    </AnimationFadeIn>
  );
};

export default FoundedTrainingCorporate;
